<template>
  <div class="gap-50 d-flex flex-column p-20 justify-content-center container">

    <div v-for="(tool, group) in resultPage.tools?.groups" class="w-100" v-if="isSelectedGroup(group)">
      <div  class="file-container">

        <div class="px-3 align-items-center bg-white p-3 font-weight-bold d-flex justify-content-space-between" :class="borderBottom(tool.color)">
          <span class="font-size-125">{{  tool.name }}</span>

          <div>
            <div class="text-muted font-weight-bold">
              <div class="m-0 alert alert-info" v-if="isAllSelected  && selectedOutputs.length !== 1">
                {{ 'All files' | trans }}
              </div>

              <div class="m-0 alert alert-warning" v-if="isNoneSelected">
                {{ 'No files selected' | trans }}
              </div>

              <div class="m-0 alert alert-info" v-if="!isNoneSelected && !isAllSelected && selectedOutputs.length !== 1">
                {{ selectedOutputs.length }} {{ 'Files' | trans }}
              </div>
              <div class="m-0 alert alert-info short-text-name" v-if="selectedOutputs.length === 1">
                {{ getSingleSelectedFilename() | decodeUrl }}
              </div>
            </div>
          </div>
      </div>

      <div class="file-item px-3 d-flex justify-content-between" v-for="(feature, operation) in tool.features_detail">
        <div class="item d-inline-flex gap-10px align-items-center">
          <div v-bind:class="getIcon(tool)"><i class="lh-inherit far" :class="feature.icon"></i></div>
          {{ feature.name }}
        </div>
        <div class="item "><div v-bind:class="{ 'disabled': selectedOutputs.length === 0 || currentJob.state === 'failed'}" @click.prevent="openContinue(feature.operation)" class="btn d-flex align-items-center btn-info gap-50">Continue with <i class="fa fa-arrow-right"></i></div></div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import ToolManager from "../../manager/ToolManager";
import Reconvert from "../../util/Reconvert";
import PreviewManager from "../../manager/PreviewManager";

export default {
  name: "Tools",
  props: {},
  components: {},
  mixins: [
    store,
      currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
    ToolManager.getTools()
  },
  filters: {
    decodeUrl(url) {
      try {
        return decodeURIComponent(url);
      } catch (e) {
        return url;
      }
    }

  },
  methods: {
    getSingleSelectedFilename() {
      let output =  this.getOutputById(this.currentJob.id, this.selectedOutputs[0]);
      return PreviewManager.getFilenameFromOutput(output);
    },
    openContinue(operation) {
      if (this.complete && this.selectedOutputs.length > 0) {
        Reconvert.continueWithSelectedTool(this.currentJob, operation);
      }
    },
    getIcon(group)
    {
      return `tool-icon bg-main-${group.color}`;
    },
    isSelectedGroup(group) {
      if (this.resultPage.activeToolGroup === 'all') {
        return true;
      }

      if (this.resultPage.activeToolGroup === 'converter' && this.resultPage.tools.converter.includes(group)) {
        return true;
      }

      if (this.resultPage.activeToolGroup === 'tools' && this.resultPage.tools.tools.includes(group)) {
        return true;
      }

      return false;
    },
    borderBottom(color) {
      return `bb-main-${color}-3`;
    },

  },
  computed: {

  }
};
</script>
<style lang="scss" scoped>
.tool-icon {
  width: 42px;
  height: 42px;
  color: white;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.short-text-name {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.spinner-basic {
  border: 2px solid #2e2e2e;
  border-right-color: transparent;

  .dark-mode & {
    border: 2px solid white;
    border-right-color: transparent;
  }
}

.global-actions-container-top {

  .dark-mode & {
  }
}

.global-actions-container {
  background: white;
  padding: 10px;

  .dark-mode & {
    background: #272727;
    color: white;
  }
}

.file-container {
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  width: 100%;
  overflow: hidden;

  .dark-mode & {
    border: 1px solid #595959;
  }
}

.file-actions {
  gap: 10px;
}

.file-item {
  .item {
    display: flex;
    align-items: center;
  }

  vertical-align: center;
  padding: 10px;
  display: flex;
  gap: 10px;
  background: white;
  border-bottom: 1px solid #CBCBCB;

  .dark-mode & {
    background: #272727;
    border-bottom: 1px solid #595959;
    color: white;
  }
}

.download-btn {
  cursor: pointer;
  background: #1266F1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.upload-btn {
  cursor: pointer;

  i {
    line-height: inherit;
  }

  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
}

.file-action-btn {
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;

  .dark-mode & {
    background: #383838;;
    border: 1px solid #595959;
    color: white;

    &:hover {
      background: #323232;
    }
  }
}

.placeholder {
  margin: 0 auto;
  max-width: 400px;
  min-height: 25px;
  height: 25px;
  overflow: hidden;
  border-radius: 9px;
  opacity: .6;
  background-color: #eee;
  transition: all 1s;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0
  }
  100% {
    background-position: 468px 0
  }
}

.animated-background {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: darkgray;
  background: linear-gradient(to right, #eeeeee 10%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 100px;
  position: relative;
}

</style>
